import { Nullable, Opt } from '@application/Types/Opt'
import { GrowthbookExperimentViewed } from '@infrastructure/GoogleTagManager/GA4Events/Growthbook'

export type PermissionType = 'denied' | 'granted'

type Ga4Event = {
    event: 'ga4Event'
}

type VirtualPageViewGa4Event = Ga4Event & {
    event_name: 'virtualPageview'
    page_path: string
    page_title: string
}

type CookiePermissionUpdateGa4Event = Ga4Event & {
    event_name: 'cookieUpdate'
    analytics_storage: PermissionType
    ad_storage: PermissionType
    ad_user_data: PermissionType
    ad_personalization: PermissionType
}

type CookiePermissionDefaultGa4Event = Ga4Event & {
    event_name: 'cookieDefault'
    analytics_storage: PermissionType
    ad_storage: PermissionType
    ad_user_data: PermissionType
    ad_personalization: PermissionType
}

export type Ga4DataLayerPayload =
    | VirtualPageViewGa4Event
    | CookiePermissionUpdateGa4Event
    | CookiePermissionDefaultGa4Event
    | GrowthbookExperimentViewed

export const sendGa4EventToGtm = (eventPayload: Ga4DataLayerPayload): void => {
    ;(window.dataLayer ?? []).push(eventPayload)
}

export const getClientId = (): Opt<Nullable<number>> => {
    try {
        const tracker = window.ga?.getAll()[0]
        return tracker?.get('clientId')
    } catch (e) {
        return null
    }
}
